import React from 'react';
import PropTypes from 'prop-types';

function Alert({ fill, className }) {
  return (
    <svg
      className={className}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="20"
      viewBox="0 0 22 19"
    >
      <g
        id="Review-Funnel"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Write-a-Review_desktop-error-msg"
          transform="translate(-880, -515)"
          fill={fill}
          fillRule="nonzero"
        >
          <path d="M900.026609,534 L892.030391,520.160391 L884,534 L900.026609,534 Z M892.748,528.908391 L891.278609,528.908391 L891.278609,525.969609 L892.748,525.969609 L892.748,528.908391 Z M892.748,531.813 L891.278609,531.813 L891.278609,530.343609 L892.748,530.343609 L892.748,531.813 Z" />
        </g>
      </g>
    </svg>
  );
}

Alert.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
};

Alert.defaultProps = {
  fill: '#FF585B',
  className: '',
};

export default Alert;
